import { Grid, Tooltip} from "@mui/material";

export function getPhproductStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'You must enter Party Name',
            required:true,
            fieldtype:'bodynamiclist'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        status:{
            name:'status',
            label:'Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        boxesrequired:{
            name:'boxesrequired',
            label:'Boxes Required',
            value:'',
            error:false,
            errorMessage:'You must enter Boxes Required',
            required:true,
            fieldtype:'number'
        },
        form:{
            name:'form',
            label:'Form',
            value:'',
            error:false,
            errorMessage:'You must enter Form',
            required:true,
            fieldtype:'bodynamiclist'
        },
        packagingmaterial:{
            name:'packagingmaterial',
            label:'Packaging Material',
            value:'',
            error:false,
            errorMessage:'You must enter Packaging Material',
            required:true,
            fieldtype:'bodynamiclist'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'partyname', headerName: 'Party Name', width:50 },
        { field: 'title', headerName: 'Title', width:50 },
        { field: 'status', headerName: 'Status', width:50 },
        { field: 'boxesrequired', headerName: 'Boxes Required', width:150 },
        { field: 'form', headerName: 'Form', width:150 },
        { field: 'packagingmaterial', headerName: 'Packaging Material', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['status']:{
          ...formValues['status'],
          value:data.status,
        },['boxesrequired']:{
          ...formValues['boxesrequired'],
          value:data.boxesrequired,
        },['form']:{
          ...formValues['form'],
          value:data.form,
        },['packagingmaterial']:{
          ...formValues['packagingmaterial'],
          value:data.packagingmaterial,
        },
      })
}